module.exports = __webpack_public_path__ + "img/undTooth4.9bdd3ab7.png";